import LegalHeader from "@/components/LegalHeader";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-background">
      <LegalHeader />
      <main className="pt-20 pb-16">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-primary mb-4">
                Privacy Policy
              </h1>
              <p className="text-muted-foreground">
                Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}
              </p>
            </div>

            <div className="prose prose-lg max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">1. Titolare del Trattamento</h2>
                <p>
                  <strong>Ristorante Da Armando</strong><br />
                  Via Aganoor Pompili, 25<br />
                  06065 Passignano sul Trasimeno (PG)<br />
                  P.IVA: 03963890540<br />
                  Email: info@ristorantearmando.it<br />
                  Tel: +39 075 388 0397
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">2. Finalità del Trattamento</h2>
                <p>I Suoi dati personali saranno trattati per le seguenti finalità:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Gestione delle prenotazioni e dei servizi richiesti</li>
                  <li>Comunicazioni relative ai servizi offerti</li>
                  <li>Invio di newsletter e comunicazioni promozionali (solo con consenso esplicito)</li>
                  <li>Adempimenti di legge e contabili</li>
                  <li>Miglioramento dei servizi offerti</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">3. Base Giuridica</h2>
                <p>Il trattamento dei dati si basa su:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Esecuzione del contratto per la gestione delle prenotazioni</li>
                  <li>Legittimo interesse per il miglioramento dei servizi</li>
                  <li>Consenso esplicito per marketing e newsletter</li>
                  <li>Adempimento di obblighi di legge</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">4. Categorie di Dati Trattati</h2>
                <p>Trattiamo le seguenti categorie di dati personali:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Dati anagrafici (nome, cognome)</li>
                  <li>Dati di contatto (email, telefono)</li>
                  <li>Dati relativi alle prenotazioni (data, ora, numero persone)</li>
                  <li>Dati di navigazione del sito web</li>
                  <li>Dati di utilizzo dei servizi</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">5. Conservazione dei Dati</h2>
                <p>I dati personali saranno conservati per:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Dati di prenotazione: 10 anni (obblighi contabili)</li>
                  <li>Dati di contatto per marketing: fino alla revoca del consenso</li>
                  <li>Dati di navigazione: 12 mesi</li>
                  <li>Dati per finalità di legge: secondo i termini di legge</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">6. Diritti dell'Interessato</h2>
                <p>Lei ha il diritto di:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Accedere ai propri dati personali</li>
                  <li>Rettificare i dati inesatti</li>
                  <li>Cancellare i propri dati (diritto all'oblio)</li>
                  <li>Limitare il trattamento</li>
                  <li>Portabilità dei dati</li>
                  <li>Opporsi al trattamento</li>
                  <li>Revocare il consenso</li>
                  <li>Proporre reclamo all'Autorità Garante</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">7. Cookie</h2>
                <p>Il nostro sito utilizza cookie tecnici necessari per il funzionamento del sito e cookie analitici per migliorare l'esperienza utente. Per maggiori informazioni, consulti la nostra Cookie Policy.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">8. Sicurezza</h2>
                <p>Adottiamo misure di sicurezza tecniche e organizzative appropriate per proteggere i Suoi dati personali da accessi non autorizzati, divulgazione, alterazione o distruzione.</p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-primary mb-4">9. Contatti</h2>
                <p>Per esercitare i Suoi diritti o per qualsiasi domanda sulla privacy, può contattarci:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Email: info@ristorantearmando.it</li>
                  <li>Telefono: +39 075 388 0397</li>
                  <li>Posta: Via Aganoor Pompili, 25, 06065 Passignano sul Trasimeno (PG)</li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy; 